import "./corporate.css";

import React from "react";
import { Button, TextField, Select, FormControl, InputLabel, MenuItem, CircularProgress } from "@material-ui/core";

import { LOADING_STATE, PAGE_ROUTES } from "../../utils/stateTypes";
import SEO_DATA from "../../utils/seoData";
import SeoHead from "../general/SeoHead";

const styles = {
  headerButton: {
    padding: "15px 30px",
  },
  featureButton: {
    width: "100%",
    marginTop: 5,
    height: 60,
    textTransform: "none",
    fontSize: "1em",
    lineHeight: "1.2em",
  },
  inputHalf: {
    width: "calc(50% - 10px)",
    marginBottom: 20,
    marginRight: 20,
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  inputHalf2: {
    width: "calc(50% - 10px)",
    marginBottom: 20,
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  input: {
    marginBottom: 20,
    textAlign: "left",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  submit: {
    padding: "15px",
  },
};

const sendMessage = async (name, email, type, phone, company, location, message, setSendState) => {
  setSendState(LOADING_STATE.LOADING);
  const response = await fetch("/api/Contact/SendCorporateRequest", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name,
      email,
      phone,
      type,
      company,
      location,
      message,
    }),
  });
  if (response.ok) {
    setSendState(LOADING_STATE.LOADED);
  }
  else {
    setSendState(LOADING_STATE.ERROR);
  }
};


const Corporate = () => {

  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [type, setType] = React.useState("Multiple services");
  const [phone, setPhone] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [location, setLocation] = React.useState("Johannesburg");
  const [message, setMessage] = React.useState("");
  const [sendState, setSendState] = React.useState(LOADING_STATE.NOT_LOADING);

  let submitLabel = "Send";
  if (sendState === LOADING_STATE.LOADING) {
    submitLabel = <CircularProgress size={25} />;
  }
  else if (sendState === LOADING_STATE.LOADED) {
    submitLabel = "Sent!";
  }
  else if (sendState === LOADING_STATE.ERROR) {
    submitLabel = "Retry";
  }

  return (
    <main>
      <SeoHead
        {...SEO_DATA[PAGE_ROUTES.CORPORATE]}
        path={PAGE_ROUTES.CORPORATE}
      />

      {/* ================================== HERO ================================== */}
      <header className={"home-header"}>
        <div className={"standard-width"}>
          <div className={"home-header-content"}>
            <h1>Corporate Offering</h1>
            <p>Creating a <i>balanced</i> lifestyle<br />for your corporate team</p>
            <Button
              variant={"contained"}
              color={"primary"}
              style={styles.headerButton}
              size={"large"}
              onClick={() => {
                document.getElementById("corporate-quote").scrollIntoView({ behavior: "smooth" });
              }}
            >
              Request a quote
            </Button>
          </div>
        </div>
        <img
          src={"/images/corporate/hero.webp"}
          className={"home-header-img corporate"}
          alt={"Ash The Dietitian Corporate Offering Header"}
        />
      </header>

      <section className={"home-features-section standard-width"}>
        <h2 className={"section-head"}>Corporate services</h2>
        <div className={"home-features corporate"}>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-1.webp"}
              alt={"Health Screen or Discovery Vitality Assessments"}
            />
            <Button
              variant={"contained"}
              color={"secondary"}
              style={styles.featureButton}
              onClick={() => {
                setType("Health screen or Discovery Vitality assessments");
                document.getElementById("corporate-quote").scrollIntoView({ behavior: "smooth" });
              }}
            >
              Health Screen or Discovery Vitality Assessments
            </Button>
          </div>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-2.webp"}
              alt={"Individual Employee Consultations"}
            />
            <Button
              variant={"contained"}
              color={"secondary"}
              style={styles.featureButton}
              onClick={() => {
                setType("Individual employee consultations");
                document.getElementById("corporate-quote").scrollIntoView({ behavior: "smooth" });
              }}
            >
              Individual Employee Consultations
            </Button>
          </div>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-3.webp"}
              alt={"Group Consultations and Programs"}
            />
            <Button
              variant={"contained"}
              color={"secondary"}
              style={styles.featureButton}
              onClick={() => {
                setType("Group consultations and programs");
                document.getElementById("corporate-quote").scrollIntoView({ behavior: "smooth" });
              }}
            >
              Group Consultations and Programs
            </Button>
          </div>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-4.webp"}
              alt={"Corporate Wellness Days"}
            />
            <Button
              variant={"contained"}
              color={"secondary"}
              style={styles.featureButton}
              onClick={() => {
                setType("Corporate wellness days");
                document.getElementById("corporate-quote").scrollIntoView({ behavior: "smooth" });
              }}
            >
              Corporate Wellness Days
            </Button>
          </div>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-5.webp"}
              alt={"Canteen Assessments and Health Advice"}
            />
            <Button
              variant={"contained"}
              color={"secondary"}
              style={styles.featureButton}
              onClick={() => {
                setType("Canteen assessments and health advice");
                document.getElementById("corporate-quote").scrollIntoView({ behavior: "smooth" });
              }}
            >
              Canteen Assessments and Health Advice
            </Button>
          </div>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-6.webp"}
              alt={"Wellness Nutrition Talks"}
            />
            <Button
              variant={"contained"}
              color={"secondary"}
              style={styles.featureButton}
              onClick={() => {
                setType("Wellness nutrition talks");
                document.getElementById("corporate-quote").scrollIntoView({ behavior: "smooth" });
              }}
            >
              Wellness Nutrition Talks
            </Button>
          </div>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-7.webp"}
              alt={"Office Weight Loss Camps"}
            />
            <Button
              variant={"contained"}
              color={"secondary"}
              style={styles.featureButton}
              onClick={() => {
                setType("Office weight loss camps");
                document.getElementById("corporate-quote").scrollIntoView({ behavior: "smooth" });
              }}
            >
              Office Weight Loss Camps
            </Button>
          </div>
          <div className={"home-feature"}>
            <img
              className={"home-feature-icon"}
              src={"/images/home/feature-8.webp"}
              alt={"Corporate Wellness Newsletters"}
            />
            <Button
              variant={"contained"}
              color={"secondary"}
              style={styles.featureButton}
              onClick={() => {
                setType("Corporate wellness newsletters");
                document.getElementById("corporate-quote").scrollIntoView({ behavior: "smooth" });
              }}
            >
              Corporate Wellness Newsletters
            </Button>
          </div>
        </div>
      </section>

      <section className={"companies-section standard-width"}>
        <h2 className={"section-head"}>Companies we've worked with</h2>
        <div className={"companies standard-box"}>
          <img
            src={"/images/corporate/company1.webp"}
            alt={"Virgin Active"}
          />
          <img
            src={"/images/corporate/company2.webp"}
            alt={"Pharam Dynamic"}
          />
          <img
            src={"/images/corporate/company3.webp"}
            alt={"UBS"}
          />
          <img
            src={"/images/corporate/company4.webp"}
            alt={"CAMAF"}
          />
          <img
            src={"/images/corporate/company5.webp"}
            alt={"Expresso"}
          />
          <img
            src={"/images/corporate/company6.webp"}
            alt={"Discovery"}
          />
          <img
            src={"/images/corporate/company8.webp"}
            alt={"SABC"}
          />
          <img
            src={"/images/corporate/company9.webp"}
            alt={"Legal Aid"}
          />
          <img
            src={"/images/corporate/company10.webp"}
            alt={"Vitamin Me"}
          />
          <img
            src={"/images/corporate/company11.webp"}
            alt={"Forwardzone"}
          />
          <img
            src={"/images/corporate/company12.webp"}
            alt={"CCI"}
          />
          <img
            src={"/images/corporate/company14.webp"}
            alt={"Lamelle"}
          />
          <img
            src={"/images/corporate/company13.webp"}
            alt={"Anura"}
          />
          <img
            src={"/images/corporate/company15.webp"}
            alt={"LifeLine"}
          />
          <img
            src={"/images/corporate/company16.webp"}
            alt={"ChevrahKadisha"}
          />
        </div>
      </section>

      <section
        className={"corporate-quote-section standard-width"}
        id={"corporate-quote"}
      >
        <h2 className={"section-head"}>Request a quote</h2>
        <form
          className={"corporate-quote-form standard-box"}
          onSubmit={(e) => {
            e.preventDefault();
            sendMessage(name, email, type, phone, company, location, message, setSendState);
          }}
        >
          <TextField
            label={"Name"}
            variant={"filled"}
            color={"secondary"}
            style={styles.inputHalf}
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <TextField
            label={"Email"}
            variant={"filled"}
            color={"secondary"}
            style={styles.inputHalf2}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <FormControl
            variant={"filled"}
            color={"secondary"}
            style={styles.input}
            fullWidth
          >
            <InputLabel>I am interested in</InputLabel>
            <Select
              value={type}
              onChange={(e) => setType(e.target.value)}
              MenuProps={{
                disableScrollLock: true,
              }}
              color={"secondary"}
            >
              <MenuItem
                value={"Multiple services"}
                style={styles.menuItem}
              >
                Multiple services
              </MenuItem>
              <MenuItem
                value={"Health screen or Discovery Vitality assessments"}
                style={styles.menuItem}
              >
                Health screen or Discovery Vitality assessments
              </MenuItem>
              <MenuItem
                value={"Individual employee consultations"}
                style={styles.menuItem}
              >
                Individual employee consultations
              </MenuItem>
              <MenuItem
                value={"Group consultations and programs"}
                style={styles.menuItem}
              >
                Group consultations and programs
              </MenuItem>
              <MenuItem
                value={"Corporate wellness days"}
                style={styles.menuItem}
              >
                Corporate wellness days
              </MenuItem>
              <MenuItem
                value={"Canteen assessments and health advice"}
                style={styles.menuItem}
              >
                Canteen assessments and health advice
              </MenuItem>
              <MenuItem
                value={"Wellness nutrition talks"}
                style={styles.menuItem}
              >
                Wellness nutrition talks
              </MenuItem>
              <MenuItem
                value={"Office weight loss camps"}
                style={styles.menuItem}
              >
                Office weight loss camps
              </MenuItem>
              <MenuItem
                value={"Corporate wellness newsletters"}
                style={styles.menuItem}
              >
                Corporate wellness newsletters
              </MenuItem>
            </Select>
          </FormControl>
          <TextField
            label={"Phone number"}
            variant={"filled"}
            color={"secondary"}
            style={styles.inputHalf}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <TextField
            label={"Company"}
            variant={"filled"}
            color={"secondary"}
            style={styles.inputHalf2}
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            required
          />
          <FormControl
            variant={"filled"}
            color={"secondary"}
            style={styles.input}
            fullWidth
          >
            <InputLabel>Location</InputLabel>
            <Select
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              MenuProps={{
                disableScrollLock: true,
              }}
              color={"secondary"}
            >
              <MenuItem
                value={"Johannesburg"}
                style={styles.menuItem}
              >
                Johannesburg
              </MenuItem>
              <MenuItem
                value={"Cape Town"}
                style={styles.menuItem}
              >
                Cape Town
              </MenuItem>
            </Select>
          </FormControl>
          <TextField
            label={"Message"}
            variant={"filled"}
            color={"secondary"}
            style={styles.input}
            fullWidth
            multiline
            minRows={4}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
          <Button
            variant={"contained"}
            color={"primary"}
            type={"submit"}
            fullWidth
            style={styles.submit}
            disabled={(sendState === LOADING_STATE.LOADING || sendState === LOADING_STATE.LOADED)}
          >
            {submitLabel}
          </Button>
        </form>
      </section>
    </main>
  );
};

export default Corporate;

